module.exports = __webpack_public_path__ + "media/images/emblems/Grancy-coat_of_arms-ea753e772f4cd426c32e69a885af1033.svg";